var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"wh-fade-toast"}},[(_vm.is_show)?_c('div',{staticClass:"wh-toast",on:{"touchmove":function($event){if($event.target !== $event.currentTarget)return null;$event.preventDefault();}}},[_c('div',{staticClass:"wh-toast-message"},[_vm._v("\n      "+_vm._s(_vm.content)+"\n    ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }